<template>
    <el-row :gutter="20">
        <el-col :span="24">
            <div  class="goToSection">
                <h3>{{ $t('goToSection.seeAlso') }}</h3>
                <ul>
                    <li>
                        <h4>{{ $t('goToSection.documentation') }}</h4>
                        <p>
                            {{ $t('goToSection.description') }} <a :href="ROUTING.autopaySdk.docs.android">Android</a>&nbsp;{{ $t('goToSection.and') }}&nbsp;<a :href="ROUTING.autopaySdk.docs.ios">iOS</a>
                        </p>
                        <a class="btn btn-blue" :href="ROUTING.autopaySdk.docs.main">{{ $t('goToSection.link') }}</a>
                    </li>
                    <li>
                        <h4>{{ $t('goToSection.download') }}</h4>
                        <p>
                            {{ $t('goToSection.filesDescription') }} <a :href="ROUTING.autopaySdk.files.android">Android</a>&nbsp;{{ $t('goToSection.and') }}&nbsp;<a :href="ROUTING.autopaySdk.files.ios">iOS</a>
                        </p>
                        <a class="btn btn-blue" :href="ROUTING.autopaySdk.files.main">{{ $t('goToSection.link') }}</a>
                    </li>
                </ul>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { ROUTING } from '../../const/routing.const'

export default {
  name: 'LayoutGoToSection',
  data () {
    return {
      ROUTING: ROUTING
    }
  }
}
</script>
<style src="../../assets/scss/GoToSection.scss" lang="scss"></style>
